export default function initHeader() {
  let lastScrollTop = 0;
  const mainWrapper = document.getElementById('wrapper') as HTMLElement;
  const autohideElement = document.getElementById('header') as HTMLElement;

  function positionHeader() {
    const scrollTop = window.scrollY;
    if (scrollTop === 0) {
      autohideElement.classList.add('scrolled-top');
      autohideElement.classList.remove('scrolled-down', 'scrolled-up');

      mainWrapper.classList.add('scrolled-top');
      mainWrapper.classList.remove('scrolled-down', 'scrolled-up');
    } else if (scrollTop < lastScrollTop) {
      autohideElement.classList.remove('scrolled-top', 'scrolled-down');
      autohideElement.classList.add('scrolled-up');

      mainWrapper.classList.remove('scrolled-top', 'scrolled-down');
      mainWrapper.classList.add('scrolled-up');
    } else {
      autohideElement.classList.remove('scrolled-top', 'scrolled-up');
      autohideElement.classList.add('scrolled-down');

      mainWrapper.classList.remove('scrolled-top', 'scrolled-up');
      mainWrapper.classList.add('scrolled-down');
    }
    lastScrollTop = scrollTop;
  }

  if (autohideElement && mainWrapper) {
    document.addEventListener('DOMContentLoaded', () => {
      window.addEventListener('scroll', () => {
        positionHeader();
      });
      positionHeader();
    });
  }
  Alpine.data('header', () => ({
    hover: false,
    open: false,
    openDropdownKey: '',
    openAccount: false,
    openLangDropdown: false,
    sectionHover: 0,
    toggleMenuSectionOpen() {
      const button = this.$el;
      const { parentElement } = button;
      const { key, lvl } = button.dataset;
      // close all other open dropdowns
      this.closeAllMenuSections(parentElement, lvl);
      // toggle current dropdown
      if (key) {
        this.openDropdownKey = this.openDropdownKey === key ? '' : key;
        if (key === 'menu-lang') {
          this.openLangDropdown = !this.openLangDropdown;
        }

        if (parentElement) {
          parentElement.classList.toggle('drop-active');
          const buttons = parentElement.getElementsByTagName('button');
          Array.from(buttons).forEach((btn) => {
            // eslint-disable-next-line no-param-reassign
            btn.ariaExpanded = btn.ariaExpanded === 'true' ? 'false' : 'true';
          });
        }
      }
    },
    closeAllMenuSections(currentItem?: Element | null, lvl?: string | null) {
      let navItems: NodeListOf<Element> = document.querySelectorAll('.group\\/nav-item, .group\\/sub-menu');
      if (lvl && lvl > '1') {
        navItems = document.querySelectorAll(`.group\\/nav-item[data-lvl="${lvl}"], .group\\/sub-menu[data-lvl="${lvl}"]`);
      }
      Array.from(navItems).forEach((item) => {
        if (item !== currentItem) {
          this.openDropdownKey = '';
          this.openLangDropdown = false;
          item.classList.remove('drop-active');
          const otherButtons = item.getElementsByTagName('button');
          Array.from(otherButtons).forEach((btn) => {
            // eslint-disable-next-line no-param-reassign
            btn.ariaExpanded = 'false';
          });
        }
      });
    },
    toggleSearchOpen() {
      this.openDialog();
      document.getElementById('mobile-search')?.focus();
    },
    openDialog() {
      this.open = true;
      document.body.style.overflowY = 'hidden';
      document.getElementById('header')?.classList.add('nav-active');
    },
    closeDialog() {
      this.open = false;
      document.body.style.overflowY = 'initial';
      document.getElementById('header')?.classList.remove('nav-active');
      this.closeAllMenuSections();
      this.$nextTick(() => {
        setTimeout(() => {
          document.getElementById('main-menu-opener')?.focus();
        }, 20); // We have to wait for the DOM to be updated so that the searchInput is focusable
      });
    },
  }));
}
